import i18next from 'i18next';

i18next.addResources('en', 'FORGOT_PASSWORD', {
  TITLE: 'Forgot Password',
  FORM_TITLE: 'Forgot your password?',
  FORM_SUBTITLE: 'Enter your email address and we will send you instructions to reset it.',
  EMAIL_LABEL: 'Email address',
  EMAIL_PLACEHOLDER: 'example@mail.com',
  SUBMIT_BUTTON: 'Send reset link',
  SUCCESS_TITLE: 'Email sent!',
  SUCCESS_MESSAGE: 'Check your inbox. We have sent you a link to create a new password.',
  ERROR_GENERIC: 'There was an error processing your request. Please try again.',
});

i18next.addResources('es', 'FORGOT_PASSWORD', {
  TITLE: 'Recuperar contraseña',
  FORM_TITLE: '¿Olvidaste tu contraseña?',
  FORM_SUBTITLE:
    'Ingresá tu correo electrónico y te enviaremos las instrucciones para restablecerla.',
  EMAIL_LABEL: 'Correo electrónico',
  EMAIL_PLACEHOLDER: 'ejemplo@correo.com',
  SUBMIT_BUTTON: 'Enviar enlace de recuperación',
  SUCCESS_TITLE: '¡Correo enviado!',
  SUCCESS_MESSAGE:
    'Revisá tu bandeja de entrada. Te enviamos un enlace para que puedas generar una nueva contraseña.',
  ERROR_GENERIC: 'Hubo un error al procesar tu solicitud. Por favor, intentá de nuevo.',
});
